/**
 * 路由模块汇总
 * @description 汇总所有路由配置模块
 */
import type { RouteRecordRaw } from 'vue-router'

// 导入各模块路由
import adminRoutesv2 from './routes/adminRoutes'
import authRoutesv2 from './routes/authRoutes'
import modelRoutesv2 from './routes/modelRoutes'
import serviceCenterRoutesv2 from './routes/serviceCenterRoutes'
import taskRoutesv2 from './routes/taskRoutes'
import userRoutesv2 from './routes/userRoutes'

// 导入公共路由
const publicRoutes: RouteRecordRaw[] = [
  {
    path: '/',
    redirect: '/home',
  },
  {
    path: '/v2',
    redirect: '/home',
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('@/views/Home.vue'),
    meta: {
      title: '首页',
      requiresAuth: false,
      cache: true,
    },
  },
  // 维护模式页面
  {
    path: '/maintenance',
    name: 'MaintenancePage',
    component: () => import('@/views/common/MaintenancePage.vue'),
    meta: {
      title: '系统维护中',
      requiresAuth: false,
    },
  },
  // 错误页面
  {
    path: '/error/403',
    name: 'ForbiddenPage',
    alias: '/forbidden',
    component: () => import('@/views/error/ForbiddenPage.vue'),
    meta: {
      title: '权限不足',
      requiresAuth: false,
    },
  },
  {
    path: '/error/404',
    name: 'NotFoundPage',
    component: () => import('@/views/NotFound.vue'),
    meta: {
      title: '页面未找到',
      requiresAuth: false,
    },
  },
  {
    path: '/error/500',
    name: 'ServerError',
    alias: '/server-error',
    component: () => import('@/views/error/ServerError.vue'),
    meta: {
      title: '服务器错误',
      requiresAuth: false,
    },
  },
]

// 汇总所有路由配置
const routes: RouteRecordRaw[] = [
  ...publicRoutes,
  ...authRoutesv2,
  ...modelRoutesv2,
  ...taskRoutesv2,
  ...userRoutesv2,
  ...serviceCenterRoutesv2,
  ...adminRoutesv2,
  // 404 路由建议最后添加
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/views/NotFound.vue'),
    meta: {
      title: '404 Not Found',
      requiresAuth: false,
    },
  },
]

export default routes
